export const no = {
  message: {
    layout: {
      login: 'Logg inn',
      logout: 'Logg ut',
      customers: 'Kunder',
      crm: 'CRM',
      dashboard: 'Dashbord',
      settings: 'Innstillinger',
      timer: 'Time håndtering',
      user: 'Brukere',
      userRole: 'Brukerrolle',
      productType: 'Produkttyper',
      priorities: 'Prioriteringer',
      ticketStatus: 'Sakstatus',
      ticketTypes: 'Sakstype',
      department: 'Avdeling',
      groups: 'Gruppe',
      ticket: 'Ticket',
      mailConfiguration: 'E-post konfigurasjon',
      systemConfiguration: 'Systemkonfigurasjon',
      hse: 'HMS',
      product: 'Produkt',
      products: 'Produkter',
      order: 'Ordre',
      tools: 'Verktøy',
      deviation: 'Avvik',
      deviationCategory: 'Avvikskategori',
      deviationLocation: 'Lokasjon',
      deviationStatus: 'Status',
      onedriveSetting: 'OneDrive instillinger',
      sharepointSetting: 'Sharepoint instillinger',
      sharepointCredential: 'SharePoint legitimasjon',
      clearOneDrive: 'Tømme OneDrive',
      category: 'Kategori',
      location: 'Lokasjon',
      priority: 'Prioritet',
      status: 'Status',
      deviations: 'Avvik',
      tickets: 'Saker',
      types: 'Typer',
      sharepoint: 'Sharepoint',
      crmSettings: 'CRM instillinger',
      industries: 'Bransjer',
      shipments: 'Transportører',
      permission: 'Tillatelser',
      currencies: 'Valutakurser',
      salesAccounts: 'Salgskonto',
      productGroup: 'Varegruppe',
      productUnit: 'Produktenhet',
      warehouseSettings: 'Lager innstillinger',
      warehouse: 'Lager',
      warehouseLocations: 'Lagerlokasjon',
      offer: 'Tilbud',
      grossMargin: 'Avanse',
      discountGroups: 'Rabbat grupper',
      orderOrOffer: 'Tilbud/Ordre',
      productionOrder: 'Produksjonsordre',
      reports: 'Rapporter',
      workFlow: 'Arbeidsflyt',
      WorkFlowStates: 'Workflow States',
      employees: 'Ansatte',
      returnForm: 'Returskjema',
      checklist: 'Sjekkliste',
      checklists: 'Sjekklister'
    },
    login: {
      language: 'Språk',
      back: 'Tilbake',
      userName: 'Brukernavn',
      password: 'Brukerpassord',
      authFailed: 'Godkjenning mislyktes',
      enterUserName: 'Skriv inn brukernavn',
      enterPassword: 'Skriv inn passord',
      enterConfirmPassword: 'Gjenta passord',
      resetNow: 'Nullstill',
      invalidPassword: 'Ugyldig passord',
      unauthorizedMsg: 'Ingen tillatelse',
      forgotPassword: 'Glemt passord?',
      mailNotFound: 'Epostadressen ekisterer ikke',
      linkShared: 'Lenke for tilbakestilling av passord har blitt sendt!',
      loginWithSharepoint: 'Login med Sharepoint'
    },
    common: {
      english: 'Engelsk',
      norwegian: 'Norsk',
      save: 'Lagre',
      send: 'Send',
      edit: 'Endre',
      cancel: 'Avbryt',
      update: 'Oppdater',
      delete: 'Slett',
      updateAndClose: 'Oppdater og lukk',
      close: 'Lukk',
      new: 'Ny',
      isActive: 'Er aktiv',
      addNew: 'Legg til',
      action: 'Handling',
      required_message: 'Feltet er obligatorisk',
      savedSuccess: 'Lagret',
      addedSucess: 'Opprettet',
      updatedSuccess: 'Oppdatert',
      uploadedSuccess: 'Lastet opp!',
      deleteSuccess: 'Slettet',
      backToList: 'Tilbake til listen',
      search: 'Søk',
      yes: 'Ja',
      no: 'Nei',
      isDefault: 'Er standard',
      loadingMsg: 'Laster inn, vennligst vent',
      deleteConfirm: 'Bekreft sletting',
      areYouSure: 'Er du sikker på at du vil slette?',
      validationIssue: 'Vennligst sjekk de obligatoriske feltene!',
      total: 'Total',
      noResults: 'Ingen resultater funnet!',
      others: 'Andre',
      typeHere: 'Skriv inn her...',
      position: 'Posisjon',
      color: 'Farge',
      maxCharacters: 'Maks {charCount} tegn',
      changedPassword: 'Passord endret',
      import: 'Import',
      note: 'Notat',
      invalidEmail: 'Ugyldig e-post',
      no_records: 'Ingen resultater funnet!',
      ok: 'Ok',
      syncedSuccess: 'Synkronisert',
      comments: 'Kommentarer',
      export: 'Eksport',
      importProducts: 'Importer produkter',
      importSuppliers: 'Importer leverandører',
      importSuccess: 'Importert!',
      exportProducts: 'Eksport Products',
      days: 'dager',
      draft: 'Kladd',
      sent: 'Sendt',
      accepted: 'Akseptert',
      notAccepted: 'Ikke akseptert',
      ordered: 'Bestilt',
      inProgress: 'Pågår',
      received: 'Mottat',
      receive: 'Mottat',
      partiallyReceived: 'Delvis mottat',
      request: 'Forespørsel',
      partiallyPicked: 'Delvis hentet',
      picked: 'Hentet',
      normal: 'Normal',
      high: 'Høy',
      low: 'Lav',
      medium: 'Middels',
      qtyExceeds: 'Antall overskrider',
      difference: 'Forskjellen',
      completedBy: 'Fullført av',
      completedAt: 'Fullført på',
      completed: 'Fullført',
      complete: 'Ferdig',
      ccsheet_warehouse_exists: 'Uferdig ark for denne varehus',
      batchExists: 'Batchnummer eksisterer allerede!',
      actionPerformed: 'Vellykket handling',
      receivedOn: 'Mottatt den',
      add_extra_mails: 'Bruk komma for å legge inn flere epost adresser',
      copy_to_me: 'Kopi til meg',
      order_report: 'Order report',
      orderConfirm: 'Ordrebekreftelse',
      invalidDataFound: 'Ugyldige data funnet!',
      warning: 'Varsel!',
      changes_saved: 'Endringene er ikke lagret',
      are_you_navigate: 'Vil du navigere bort?',
      information: 'Informasjon',
      both: 'Begge',
      add: 'Legg til',
      actions: 'Handlinger',
      create: 'Opprett',
      validMessage: 'Er ugyldig',
      action_sucess: 'Vellykket handling !',
      created_success: 'Opprettet ny !',
      notFound: 'Not found!',
      select: 'Velg',
      useEnterToAddMore: 'Use enter key to add more!',
      modifiedOn: 'Endret',
      modifiedBy: 'Endret av',
      searchTriggerHint: '(Hit enter or click search icon)',
      confirmation: 'Bekreftelse',
      pickedqty: 'Leveres'
    },
    dashboard: {
      new: 'Ny',
      orders: 'Bestillinger',
      inProgress: 'I prosess',
      cancelled: 'Avbrutt',
      closed: 'Lukket',
      day: 'Dag',
      today: 'I dag',
      monthly: 'Måned',
      annual: 'Årlig',
      noOfTickets: 'Antall billetter',
      byDay: 'Daglig',
      byWeek: 'Ukentlig',
      byMonth: 'Månedlig',
      byYear: 'Årlig',
      totalCustomers: 'Totalt kunder',
      totalOrders: 'Totalt bestillinger',
      totalHours: 'Totalt antall timer',
      testWidget: 'Test modul',
      topProduced: 'Top 5 produsert',
      thisWeek: 'Denne uken',
      lastWeek: 'Forrige uke',
      thisMonth: 'Denne måned',
      lastMonths: 'Forrige måned',
      boats: 'Båter',
      boatsProduced: 'Båter produsert'
    },
    customer: {
      name: 'Navn',
      address: 'Adresse',
      addressType: 'Type',
      country: 'Land',
      post: 'Post',
      city: 'By',
      municipality: 'Kommune',
      phone: 'Telefonnummer',
      email: 'E-post',
      web: 'Nettsted',
      description: 'Beskrivelse',
      addCustomer: 'Legg til kunde',
      updateCustomer: 'Oppdater kunde',
      contacts: 'Kontakter',
      addContact: 'Legg til kontakt',
      updateContact: 'Oppdater kontakt',
      telephone: 'Hjemmenummer',
      mobile: 'Mobilnummer',
      jobTitle: 'Jobb',
      addAddress: 'Legg til adresse',
      updateAddress: 'Oppdater adresse',
      postbox: 'Postboks',
      postCode: 'Postnummer',
      latitude: 'Breddegrad',
      longitude: 'Lengdegrad',
      coordinates: 'Koordinater',
      isStandard: 'Er standard',
      receiveCertificate: 'Mottaker av sertifikat',
      customerOrSupplier: 'Kunde/Leverandør',
      activeOrInactive: 'Aktiv/Inaktiv',
      active: 'Aktiv',
      Inactive: 'Inaktiv',
      status: 'Status',
      priority: 'Prioritet',
      buyingCustomer: 'Kjøpende kunde',
      potentialCustomer: 'Potensiell kunde',
      vat: 'Orgnr',
      vatValue: 'MVA',
      vatId: 'MVA kode',
      homepage: 'Hjemmeside',
      visit: 'Besøk',
      delivery: 'Levering',
      invoice: 'Faktura',
      iscustomer: 'Er kunde',
      issupplier: 'Er leverandør',
      state: 'Tilstand',
      sg: 'SG',
      direct: 'Direkte',
      ehf: 'EHF',
      pdf: 'PDF',
      paymentmethod: 'Betalingsmetode',
      industry: 'Bransje',
      shipment: 'Transportør',
      shipmentReport: 'Forsendelsesmåte',
      accountnumber: 'Kontonummer',
      addSalesAccount: 'Legg til salgskonto',
      updateSalesAccount: 'Oppdater salgskonto',
      norwegianLoc: 'Norsk',
      foreign: 'Utenlandsk',
      addons: 'Tillegg',
      noProductGroupsFound: 'Ingen produktgrupper funnet!',
      noOrdersFound: 'No orders found!',
      productGroup: 'Produktgruppe',
      notificationEmail: 'E-post varsel',
      invoiceEmail: 'Faktura epost',
      customerNumber: 'Kundenr.',
      exists: 'Kunde er allerede registrert',
      mainSupplier: 'Hovedleverandør',
      secondarySupplier: 'Tillegsleverandør',
      priceList: 'Prisliste',
      current: 'Nå',
      thisYear: 'I år',
      lastYear: 'I fjor',
      sharepointConfigNotDone: 'Sharepoint config is not done'
    },
    user: {
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      addUser: 'Legg til bruker',
      updateUser: 'Oppdater bruker',
      email: 'E-post',
      mobile: 'Mobilnummer',
      role: 'Rolle',
      pin: 'PIN-kode',
      addRole: 'Legg til brukerrolle',
      updateRole: 'Oppdater brukerrolle',
      profile: 'Profil',
      undo: 'Angre',
      clear: 'Tøm',
      sendMailNotify: 'Ønsker å få varsel fra ticket system',
      group: 'Gruppe',
      signature: 'Din underskrift',
      initial: 'Initialer',
      employeeNumber: 'Ansatt nummer',
      certificateNumber: 'Sert.nr.'
    },
    warehouse: {
      stock: 'Beholdning',
      order: 'Bestillinger',
      ccsheet: 'Varetelling',
      product: 'Produkt',
      productName: 'Produkt navn',
      addWarehouse: 'Legg til varehus',
      updateWarehouse: 'Oppdater varehus',
      addLocation: 'Legg til varehussted',
      updateLocation: 'Oppdater varehussted',
      warehouseSync: 'Sync til Shopbox & Opencart',
      openOrders: 'Åpne ordre',
      addPackageOrContent: 'Would you like to add Package or its contents?',
      contents: 'Legg til innhold',
      lowStockProposal: 'Lav beholdning',
      lowStockTitle: 'Low stock order proposal',
      warningAboutOrder: 'Vil du opprette leverandørordre med valgte produkter?',
      createAndEmail: 'Opprett og send epost',
      createOnly: 'Opprett ordre',
      createOrder: 'Ny ordre',
      ordersCreatedSuccess: 'Order(s) are created successfully!'
    },
    order: {
      orderdocuments: 'Ordredokumenter',
      orderdetails: 'Ordredetaljer',
      customer: 'Kunde',
      startDate: 'Start dato',
      endDate: 'Slutt dato',
      hours: 'Timer',
      bas: 'Gruppeleder',
      manager: 'Leder',
      date: 'Dato',
      deliveryDate: 'Leveringsdato',
      shippingDate: 'Forsendelsesdato',
      contactPerson: 'Kontaktperson',
      updatedOn: 'Oppdatert på',
      details: 'Detaljer',
      lines: 'Linjer',
      documents: 'Dokumenter',
      summary: 'Oppsummering',
      orderName: 'Ordrenavn',
      offerNumber: 'Tilbudsnummer',
      orderNumber: 'Ordrenummer',
      statusName: 'Status navn',
      paymentTerm: 'Betalingsfrist',
      paymentDate: 'Betalingsdato',
      agentName: 'Forhandlernavn',
      customerReference: 'Kundereferanse',
      deliveryCondition: 'Leveringsbetingelse',
      customerContactPerson: 'Kundekontaktperson',
      deadlineDate: 'Frist dato',
      notes: 'Merknader',
      netprice: 'Nettopris',
      estimatedhourscost: 'Estimerte kost per time',
      estimatedtotalcosts: 'Estimerte totale kostnader',
      actualhourscost: 'Faktiske timer kostnader',
      actualtotalcosts: ' Faktiske totale kostnader',
      estimatedcontributionmargin: 'Estimert bidragsmargin',
      estimatedcontributionmarginratio: 'Estimert marginalgrad',
      actualcontributionmargin: 'Faktisk bidragsmarginal',
      actualcontributionmarginratio: 'Faktisk marginalgrad',
      plannedhours: 'Planlagte timer',
      plannedservedhours: 'Planlagte serverte timer',
      plannedprogress: 'Planlagt fremgang',
      actualhours: 'Faktiske timer',
      actualservedhours: 'Faktiske serverte timer',
      actualprogress: 'Faktisk fremgang',
      noSummariesFound: 'Ingen sammendrag funnet!',
      qty: 'Stk',
      height: 'Høyde',
      customername: 'Kundenavn',
      unitprice: 'Enhetspris',
      measureunit: 'Mål enhet',
      totalnetprice: 'Total nettopris',
      totalprice: 'Totalpris',
      actualplandate: 'Faktisk plandato',
      actualstartdate: 'Faktisk startdato',
      actualenddate: 'Faktisk sluttdato',
      certificate: 'Sertifikat',
      supplier: 'Leverandør',
      batchNumber: 'Batchnummer',
      article: ' Artikkel',
      download: 'Nedlasting',
      share: 'Dele',
      emailNote: 'Bruk komma (,) for å legge til flere e-post-ID-er',
      searchByBatchNumber: 'Søk etter batchnr',
      showOrderRequire: 'Vis ordre som krever sertifikat',
      recreateCertificate: 'Gjenopprette sertifikat',
      syncNow: 'Synkroniser nå',
      sendToCustomer: 'Send til kunde',
      sendToDefined: 'Send til definerte',
      batchNo: 'Batchnr.',
      myOrder: 'Mine bestillinger',
      order: 'Bestillinger',
      deliveredQty: 'Levert',
      unableToDelete: 'Kan ikke slette!',
      orderBillingData: 'Ordre / fakturagrunnlag',
      orderOffer: 'Tilbud/Ordre',
      myTasks: 'Mine oppgaver',
      offerAccepted: 'Tilbud er bekreftet og ny ordre blir opprettet. Vil du fortsette?',
      orderedQtyHigh: 'Antall mottatt er høyere enn bestilt, vil du fortsette?  ( Ja / Nei )',
      paymentTerms: 'Bet. betingelser',
      salesOrder: 'Salgsordre',
      asMainSupplier: 'Er hoved leverandør',
      searchLocation: 'Finn lokasjon',
      rest: 'Rest',
      newProdOrder: 'Ny prod. ordre'
    },
    document: {
      title: 'Dokument',
      codename: 'Kodenavn',
      datecreated: 'Opprettet',
      documentnumber: 'Nummer',
      text: 'Tekst',
      cost: 'Kost',
      statusdate: 'Status dato',
      versionHistory: 'Version History',
      versioningDocuments: 'Versioning Documents',
      versionLabel: 'Version Label',
      size: 'Size'
    },
    product: {
      addProduct: 'Legg til produkt',
      updateProduct: 'Oppdater produktet',
      number: 'Nummer',
      shortName: 'Kort navn',
      unit: 'Enhet',
      length: 'Lengde (m)',
      width: 'Bredde (m)',
      thickness: 'Tykkelse (m)',
      weight: 'Vekt (kg)',
      certificateReq: 'Krever sertifikat',
      type: 'Type',
      image: 'Bilde',
      ignoreDiscount: 'Ignorer rabatt',
      measureUnit: 'Mål enhet',
      radius: 'Radius (mm)',
      minLength: 'Min lengde (m)',
      minWidth: 'Min bredde (m)',
      minHeight: 'Min høyde',
      minThickness: 'Min tykkelse (m)',
      maxLength: 'Maks lengde (m)',
      maxWidth: 'Maks bredde (m)',
      maxHeight: 'Maks høyde',
      maxThickness: 'Maks tykkelse (m)',
      area: 'Areal',
      supplierName: 'Leverandør navn',
      articleNumber: 'Lev. Varenr.',
      articleName: 'Varenavn',
      isStockItem: 'Lagervare',
      isInventoryItem: 'Varetelling',
      grossMargin: 'Avanse %',
      minStock: 'Min lager',
      maxstockqty: 'Maks stk antall',
      restockqty: 'Restock stk',
      deliveryDays: 'Leveringsdager',
      deleteImage: 'Slett bilde',
      addProductGroup: 'Legg til produktgroup',
      updateProductGroup: 'Oppdater produktgroup',
      costs: 'Kostnader',
      taskName: 'Oppgavenavn',
      hours: 'Timer',
      netCostPrice: 'Netto kostpris',
      additionalCostPer: 'Tilleggskostnadsprosent',
      currencyExchange: 'Valutakurs',
      costPrice: 'Innkjøpspris',
      salePrice: 'Salgspris',
      addSupplierItem: 'Legg til leverandørvare',
      updateSupplierItem: 'Oppdater leverandørvare',
      discount: 'Rabatt',
      addBatchNumber: 'Legg til batchnummer',
      updateBatchNumber: 'Oppdater batchnummer',
      work: 'Arbeid',
      prices: 'Prisene',
      priceValidFrom: 'Gyldig fra',
      salesAccount: 'Salgskonto',
      stocks: 'Beholdning',
      available: 'Tilgjengelig',
      orderQty: 'Bestillingsantall',
      measures: 'Mål',
      suppliers: 'Leverandører',
      supplierPrice: 'Veiledende pris',
      supplierDiscount: 'Rabatt %',
      discounted: 'Rabattert',
      shipmentAddon: 'Frakt tillegg%',
      other: 'Annet tillegg%',
      currency: 'Valuta',
      realCost: 'Kostpris',
      realCostNOK: 'Kostpris (NOK)',
      isMain: 'Er hoved',
      isPackage: 'Er pakke',
      packageProducts: 'Pakkeprodukter',
      shipment: 'Frakt %',
      other_per: 'Annet %',
      batchRequired: 'Batch?',
      batchOrWIN: 'Batch/WIN',
      barcode: 'Strekkode',
      attachments: 'Vedlegg',
      file: 'Filer',
      chooseFile: 'Velg fil',
      batches: 'Batch',
      batchNumber: 'Batchnummer',
      printLbl: 'Skriv ut etikket',
      reportIsReady: 'Report blir generert. Den vil bli sendt til din epost når den er klar.',
      print: 'Skriv ut',
      selectPreferredSize: 'Velg ønsket størrelse',
      exportMsg: 'Eksport fil blir generert. Den vil bli sendt til din epost når den er klar.',
      supplierNo: 'Lev.nr.',
      priceHistory: 'Pris historikk',
      salesPrice: 'Salgspris',
      wayOfUpdate: 'Way of update',
      basePrice: 'Nettopris',
      priceAdj: 'Pris just.',
      adjustByIn: 'Juster med i %',
      dateFrom: 'Gjelder fra',
      priceAdjustments: 'Pris justering',
      by_direct_update: 'Direkte',
      by_mass_adjust: 'Med massejustering',
      by_import: 'Med import',
      priceAdjustmentAdded: 'Pris historikk er blitt oppdatert',
      salePriceExVat: 'Salgspris u/mva',
      salePriceIncVat: 'Salgspris m/mva',
      exportAllData: 'Eksporter alt',
      importAllData: 'Importer alt',
      exportSupplierPrices: 'Eksporter lev. priser',
      importSupplierPrices: 'Importer lev. priser',
      supplierPriceAdjustment: 'Lev. prisjustering',
      leadTime: 'Lev. tid (dager)',
      copyWin: 'Kopier WIN',
      qty: 'Qty',
      minQty: 'Min Qty',
      addAtleastOneUnit: 'Add atleast one unit',
      salesUnit: 'Sales unit',
      supplier: 'Supplier',
      ean: 'EAN',
      package: 'Pakke'
    },
    priority: {
      addPriority: 'Legg til prioritet',
      updatePriority: 'Oppdater prioritet'
    },
    project: {
      detail_page: {
        en_name: 'Engelsk',
        no_name: 'Norsk'
      }
    },
    ticketStatus: {
      addTicketStatus: 'Legg til ticket status',
      updateTicketStatus: 'Oppdater ticket status',
      canClose: 'Kan lukkes'
    },
    group: {
      addGroup: 'Legg til gruppe',
      updateGroup: 'Oppdater gruppe'
    },
    tickets: {
      createTicket: 'Opprett ticket',
      updateTicket: 'Oppdater ticket',
      createType: 'Legg til type',
      updateType: 'Oppdater type',
      merge: 'Slå sammen',
      ticketMerge: 'Slå sammen ticket',
      chooseParentTicket: 'Velg overordnet ticket',
      changeStatus: 'Endre status',
      changePriority: 'Endre prioritet',
      changeAssignedTo: 'Endre tildelt til',
      assignTo: 'Tildele til',
      delete: 'Slett',
      mailbox: 'Postkasse',
      assignedTo: 'Tildelt til',
      unread: 'Ulest',
      number: 'Nummer',
      status: 'Status',
      type: 'Type',
      tags: 'Merker',
      priority: 'Prioritet',
      from: 'Fra',
      subject: 'Emne',
      createdOn: 'Opprettet den',
      to: 'Til',
      cc: 'Cc',
      bcc: 'Bcc',
      deleteConfirm: 'Er du sikker på at du vil slette disse tickets?',
      deleteNote: 'Å velge dette vil slette e-postene',
      selectTickets: 'Velg tickets',
      sentSuccess: 'Mail sendt!',
      mergeSuccess: 'Sammenslått',
      body: 'Hoveddel',
      note: 'Notat',
      deleteMailsTo: 'Slette e-poster også?',
      all: 'Alle',
      notAssigned: 'Ikke tildelt'
    },
    mailConfiguration: {
      name: 'Navn',
      host: 'Vert',
      port: 'Port',
      usessl: ' UseSsl',
      username: 'Brukernavn',
      password: 'Passord',
      dosync: ' DoSync',
      syncfrom: 'Synkroniser dato',
      synctime: 'Synkroniser tid',
      lastsynced: 'Sist synkronisert',
      signature: 'Mailunderskrift',
      addMailConfig: 'Legg til postkonfigurasjon',
      updateMailConfig: 'Oppdater postkonfigurasjon',
      testConnection: 'Testforbindelse',
      connectionSuccess: 'Test vellykket',
      connectionFail: 'Test mislyktes',
      action: 'Handling'
    },
    systemConfiguration: {
      ticketterm: 'Billettperiode',
      enableawb: 'Aktiver #AWB',
      syncinterval: 'Synkroniseringsintervall (minutter)',
      systemConfig: 'Ticketing konfigurasjon',
      ticketCreation: 'Ticket autosvar'
    },
    deviations: {
      title: 'Tittel',
      location: 'Lokasjon',
      category: 'Kategori',
      estimate_cost: 'Estimert kostnad',
      severity: 'Alvorlighetsgrad',
      addDeviation: 'Legg til avvik',
      updateDeviation: 'Oppdater avvik',
      reported_by: 'Rapportert av',
      reason: 'Årsaken',
      underlying_reason: 'Underliggende årsak',
      corrective_actions: 'Korrigerende tiltak',
      effective_of_measures: 'Effekt av tiltak',
      responsible: 'Ansvarlig',
      copy_to: 'Kopier til',
      created_on: 'Opprettet på',
      deadline: 'Frist',
      deviationcategories: 'Avvikskategorier',
      locationtype: 'Plasseringstype',
      printChart: 'Skriv ut diagram',
      downloadPNG: 'Last ned PNG',
      downloadJPEG: 'Last ned JPEG',
      downloadPDF: 'Last ned PDF',
      downloadSVG: 'Last ned SVG',
      statistics: 'Statistikk',
      deviation_report: 'Avviksrapport',
      retrunFormSubmit: 'Retur forespørsel registrert. Du vil bli kontaktet av Rotostøp.'
    },
    severity: {
      select: 'Velg alvorlighetsgrad',
      low: 'Lav',
      medium: 'Medium',
      high: 'Høy'
    },
    hse: {
      hseSystem: 'HMS-SYSTEM',
      uploadDocument: 'Last opp dokument',
      gettingFolders: 'Henter mapper fra SharePoint .... Vent litt ...',
      noDocuments: 'INGEN DOKUMENTER FUNNET!',
      noFolders: 'INGEN MAPPER FUNNET!',
      createNew: 'Opprett mappe',
      editName: 'Rediger mappe',
      deleteFolder: 'Slett mappe',
      upload: 'Laste opp',
      folderName: 'Mappenavn',
      files: 'Filer',
      noResponsible: 'Ingen ansvarlige',
      noDescription: 'Ingen beskrivelse',
      updateMetaData: 'Oppdater metadata',
      openNewTab: 'Åpne i ny tab',
      editMeta: 'Rediger meta'
    },
    deviationSettings: {
      addCategory: 'Legg til avvikskategori',
      updateCategory: 'Oppdater avvikskategori',
      addStatus: 'Legg til avviksstatus',
      updateStatus: 'Oppdater avviksstatus',
      addLocation: 'Legg til avviksplassering',
      updateLocation: 'Oppdater avviksplassering'
    },
    datestrings: {
      year: 'År',
      today: 'I dag',
      month: 'Måned'
    },
    onedriveSettings: {
      oneDriveSetup: 'Konfigurer grunnmappene for HMS og produkter.',
      selectHse: 'Velg HMS-grunnmappe',
      selectProduct: 'Velg produkt grunnmappe',
      selectCustomer: 'Velg kundebase',
      odLink: 'Sharepoint link'
    },
    sharepointSettings: {
      baseUrl: 'Basis url',
      siteUrl: 'Nettadresse',
      listName: 'Listenavn',
      loadFolders: 'Last inn mapper',
      loadList: 'Last Liste',
      propertiesConfig: 'Egenskaper konfigurasjon',
      contentType: 'Innholdstype'
    },
    sharePoint: {
      config: 'SharePoint Configurations',
      rootFolder: 'Root Folder'
    },
    shipment: {
      addShipment: 'Legg til forsendelse',
      updateShipment: 'Oppdater forsendelse',
      bring: 'Bring',
      tnt: 'TNT',
      postnord: 'Postnord'
    },
    industry: {
      addIndustry: 'Legg til industri',
      updateIndustry: 'Oppdater industri'
    },
    permissions: {
      manageShifts: 'Håndter vaktskift',
      manageOpencartOrders: 'Håndter opecart ordrer',
      manageShopboxOrders: 'Håndter shopbox ordrer',
      manageSettings: 'Håndter innstillinger'
    },
    currency: {
      addCurrency: 'Legg til valuta',
      updateCurrency: 'Oppdater valuta',
      exchangeRate: 'Vekslingskurs',
      validFrom: 'Gyldig fra',
      currencyHistories: 'Valutahistorikk'
    },
    unit: {
      addUnit: 'Legg til produktenhet',
      updateUnit: 'Oppdater produktenhet'
    },
    whOrder: {
      orderedQty: 'Ordered Qty',
      unitCost: 'Enhetskostnad',
      supplierOrder: 'Innkjøpsordre',
      adjustmentOrder: 'Justerings ordre',
      returnOrder: 'Returordre',
      transferOrder: 'Overføringsordre',
      addSupplierOrder: 'Legg til innkjøpsordre',
      updateSupplierOrder: 'Oppdater innkjøpsordre',
      addAdjustmentOrder: 'Legg til justerings ordre',
      updateAdjustmentOrder: 'Oppdater justerings ordre',
      addReturnOrder: 'Ny returordre',
      updateReturnOrder: 'Oppdater returordre',
      addTransferOrder: 'Ny overføringsordre',
      updateTransferOrder: 'Oppdater overføringsordre',
      orderType: 'Ordretype',
      from: 'Fra',
      to: 'Til',
      orderDate: 'Bestillingsdato',
      estimated: 'Estimert',
      pickFiles: 'Velg fil',
      orderQty: 'Bestilt',
      recQty: 'Antall mottatt',
      productNotAvailbleMsg: 'Produktet er ikke tilgjengelig i lokasjonen',
      onstockLessMsg: 'Antall skal ikke være mindre enn lager',
      sameProductMsg: 'Velg en annen produkt',
      minQty: 'Min.ant.',
      availQty: 'Tilgj.',
      sourceWH: 'Kilde whs',
      destinationWH: 'Destinasjon whs',
      pickQty: 'Hentet antall',
      loc: 'Loc',
      ordQty: 'B.ant.',
      batch: 'Batch',
      noLoc: 'Ingen',
      orderProposal: 'Bestillingsforslag',
      orderedQtyLessMsg: 'Plukket antall overstiger antall bestilt!',
      reserved: 'Reservert',
      estimateDelivery: 'Estimert/Leverings dato',
      allData: 'All data',
      supplierPrices: 'Leverandør priser',
      expireDate: 'Expiry date',
      receiveAll: 'Motta alt'
    },
    stock: {
      onStock: 'På lager',
      onOrder: 'I bestilling',
      location: 'Lokasjon',
      costPrice: 'Kostpris',
      onCustomerOrder: 'På kundeordre',
      batchOrWin: 'Batch/WIN',
      winOrProduct: 'WIN/produkt'
    },
    ccsheet: {
      scannerLocation: 'Skann / søk etter lokasjon',
      searchLocation: 'Filtrer etter lokasjon',
      addCCSheet: 'Legg til CCSheet',
      updateCCSheet: 'Oppdater CCShett',
      ongoing: ' Pågående',
      onStock: 'På lager',
      counted: 'Telt',
      recount: 'Avvikstelling',
      completed: 'Telling fullført',
      completedAndAdjusted: 'Fullført og justert',
      useScanner: 'Bruk skanner',
      noProductsFound: 'Ingen produkt funnet',
      proceed: 'Forsette',
      scanProduct: 'Skann produkt',
      ccsheetReport: 'Telleskjema',
      completeSheet: 'Vil du lukke telleskjema?',
      countedTotal: 'Totalt telt',
      totalValues: 'Total verdi',
      diff: 'Diff'
    },
    orders: {
      addOrder: 'Legg til ordre',
      updateOrder: 'Oppdater ordre',
      contact: 'Kontakt',
      deliveryAddress: 'Leveringsadresse',
      invoiceAddress: 'Fakturaaddress',
      invoiceTo: 'Faktura til',
      ourReference: 'Vår referanse',
      yourReference: 'Deres referanse',
      offerInformation: 'Ordre informasjon',
      offerComments: 'Tilbud tekst og kommentarer',
      standardSales: 'Standard salg',
      deliveryTerms: 'Leveringsvilkår',
      totalExVat: 'Totalt eks mva',
      totalSum: 'Total sum',
      productNo: 'Produktnr.',
      price: 'Pris',
      dataSheet: 'Datablad',
      searchForProduct: 'Søk etter produkt...',
      offerDate: 'Tilbudsdato',
      offerDueDate: 'Gyldig til',
      orderDate: 'Ordredato',
      deliveryDate: 'Leveringsdato',
      forProduction: 'Produksjon/plukk',
      forApproval: 'Til godkjenning',
      toInvoice: 'Til fakturering',
      invoiced: 'Fakturert',
      cancelled: 'Kansellert',
      orderDetails: 'Ordre detaljer',
      materials: 'Materialer',
      billingData: 'Faktureringsdata',
      approve: 'Godkjenn',
      addNew: 'Legg til',
      pQty: 'P.Qty',
      user: 'Bruker',
      invoiceQty: 'Faktura antall',
      addNewProduct: 'Legg til nytt produkt',
      history: 'Historikk',
      createdBy: 'Laget av',
      updatedBy: 'Updated by',
      lastUpdated: 'Sist oppdatert',
      billingTotalExVat: 'Fakturering totalt eks mva',
      offerPart: 'Tilbudslinjer',
      orderComments: 'Ordre tekst',
      stockAvailable: 'Tilgjengelig',
      planned: 'Planlagt',
      toBeShipped: 'For sending',
      shipped: 'Sendt',
      closed: 'Lukket',
      restQty: 'Rest ant.',
      contents: 'Contents',
      packList: 'Pakkseddel',
      sureToCreateOrder: 'Proceed to create production order?',
      deleted: 'Slettet',
      customerOrder: 'Kunde/Leverandør'
    },
    discountGrp: {
      customerGroup: 'Kundegrupper'
    },
    productionOrder: {
      createProduction: 'Ny produksjonsordre',
      updateProduction: 'Oppdater produksjonsordre',
      archived: 'Arkivert',
      byProduct: 'Etter produkt',
      win: 'WIN',
      winNumbers: 'WIN Numbers',
      bProduct: 'B-product',
      wishToContinue: 'Vare vil bli endret til B-vare. Bare admin bruker kan endre dette tilbake. Vil du fortsette?',
      inProduction: 'I produksjon',
      nr: 'Nr.',
      started: 'Started',
      orderStatus: 'Order status',
      productStatus: 'Product status',
      volume: 'Mengde',
      produced: 'Ferdig',
      finished: 'Fullført',
      rest: 'Rest',
      extradit: 'Utlever',
      plan_measures: 'Planmål',
      forging_measures: 'Smimål',
      order_measures: 'Best. Mål',
      plan_weight: 'Planvekt',
      forging_weight: 'Smivekt',
      weightForPresse: 'Vekt for presse',
      qtyStampedOut: 'Ant.presset',
      finalWeight: 'Ferdigvekt',
      restVolume: 'Avgang',
      weightPerPiece: 'Vekt per stykk',
      productionStatus: 'Produksjonsstatus', // copying fully from arven from nextline
      orderType: 'Ordretype',
      startDate: 'Planlagt start',
      endDate: 'Planlagt slutt',
      deliveryDate: 'Levering',
      startedDate: 'Igangsatt',
      number: 'Nummer',
      supWhs: 'Lev. / Lager',
      from: 'Fra',
      to: 'Til',
      addorder: 'Ny ordre',
      quantity: 'Antall',
      orderedqty: 'Bestilt',
      producedqty: 'Fullført',
      makingqty: 'I prod.',
      backorderqty: 'Rest',
      createOrder: 'Ny ordre',
      createProdOrder: 'Ny produksjonsordre',
      editOrder: 'Rediger',
      addPackage: 'Legg til vare/stykkliste',
      orderstatus: 'Status',
      updateOrder: 'Oppdater',
      department: 'Avdeling',
      administration: 'Administration',
      salgorService: 'Salg/service',
      showAll: 'Alle',
      myOrder: 'Mine ordre',
      myDepartment: 'Min avdeling',
      assignedToMe: 'Tildelt meg',
      normal: 'Normal',
      high: 'Høy',
      low: 'Lav',
      draft: 'Utkast',
      showonlyZero: 'Kun 0',
      draftState: 'Ny',
      newState: 'Ny',
      inProgress: 'I arbeid',
      completedState: 'Fullført',
      received: 'Mottatt',
      element: 'Stykklister',
      startedProduct: 'I produksjon',
      notStartedProduct: 'Planlagt',
      newProducts: 'Nye varer',
      startProduction: 'Start produksjon',
      quantity_exceeds: 'Antall overskrider',
      production_status: 'Produksjonsstatus',
      date_valid: 'Dato validerer ikke !',
      view_history: 'Vis historikk',
      no_history_found: 'Ingen historikk funnet',
      history_products: 'Produksjonshistorikk',
      no_quantity_found: 'Ingenting er funnet i produksjon!',
      prod_status: 'Prod Status',
      returned_to_stock: 'Returnert til lager',
      taken_from_stock: 'Taken from stock',
      split_production_row: 'Del opp produksjon',
      current_value: 'Nåværende antall for {product} er {count}',
      enter_value_to_split: 'Del opp med :',
      qty_exceeds: 'Tallet er for høyt !',
      startProductionOf: 'Antall å produsere',
      takeOut: 'Uttak fra lager',
      completeProduction: 'Fullfør arbeidsoppgave',
      rawMaterials: 'Materiell',
      newProductionStatus: 'Ny produksjonsstatus',
      productExists: 'Produkt eksisterer allerede !',
      waste: 'Kast',
      checkAvailability: 'Sjekk tilgjengelighet',
      requiredQty: 'Behov',
      availableQty: 'Tilgjengelig',
      bom: 'BOM',
      productionHistory: 'Historikk for WIN'
    },
    settings: {
      add_department: 'Ny avdeling',
      update_department: 'Oppdater avdeling',
      add_product_classes: 'Nytt Produktklasse',
      update_product_classes: 'Oppdater Produktklasse',
      add_workflow: 'Nytt arbeidsflyt',
      update_workflow: 'Endre arbeidsflyt',
      add_workflowStates: 'Ny flyt status',
      update_workflowStates: 'Endre flyt status',
      selected_workflowList: 'Selected Workflow States',
      available_workflowList: 'Available Workflow States',
      generateWin: 'Generate WIN',
      prefixForwin: 'Prefix for WIN',
      is_generate_win: 'Is Generate Win',
      wishToContinue: 'Hvis modelår er endret vil alle nye win generert med den nye modellen. Vil du fortsette?',
      changeConfirm: 'Bekreft endring?',
      add_tools: 'Legg til verktøy',
      update_tools: 'Oppdater verktøy',
      rack_name: 'Reol',
      shelf_name: 'Hylle',
      planning: 'Planlagt',
      pressing: 'Pressing',
      grinding: 'Sliping',
      silvering: 'Forsølving',
      polishing: 'Polering',
      packing: 'Pakking',
      states: 'Statuser',
      molding: 'Molding',
      bladeRetaining: 'Knivfastsetting',
      soldering: 'Lodding',
      pick_color: 'Velg farge',
      standardInvoiceText: 'Standard faktura tekst'
    },
    stocks: {
      productNumber: 'Varenr',
      desc: 'Betegnelse',
      onStock: 'Disponibelt',
      onOrder: 'I bestilling',
      productionOrder: 'Produksjonsordre',
      location: 'Lokasjon',
      orderNumber: 'Ordrenr',
      sn: 'sn',
      department: 'Avdeling',
      show: 'Vis',
      nr: 'Nr.',
      customer: 'Kunde',
      req: 'Req./Project',
      equipment: 'Utstyr',
      ordered: 'Bestilt',
      delivery: 'Levering',
      category: 'Kategori',
      po: 'PO',
      startDate: 'Start Dato',
      endDate: 'Slutt dato',
      deliveryDate: 'Levering',
      quantity: 'Antall',
      history: 'Historikk',
      import: 'Importer',
      export: 'Eksporter',
      importStock: 'Importer lager',
      importProduct: 'Importer produkt',
      time: 'Tid'
    },
    report: {
      filter_action: 'Filtre',
      select_type: 'Velg Type',
      select_report: 'Velg rapport',
      per_project: 'Per Prosjekt',
      per_customer: 'Per Kunde',
      per_activity: 'Per Aktivitet',
      show_only_sum: 'Vis kun totaler',
      show_estimation: 'Vis kun estimat',
      filter: 'Generer',
      empty_filter: 'Ingenting å vise !',
      add_extra_mails: 'Bruk komma for å legge inn flere epost adresser',
      send_report: 'Send rapport',
      only_pdf: 'PDF',
      only_xlsx: 'XLSX',
      both: 'Begge',
      time_management_report: 'Timerapport',
      select_hours_status: 'Velg status',
      estimation: 'Estimat',
      progress: 'Progress',
      file_type: 'Fil type',
      progress_total: 'Progress Totalt',
      sent_success: 'Sendt til mottaker',
      standard: 'Arbeidstid',
      absence: 'Fravær',
      email_order_details: 'Send ordre detaljer',
      copy_to_me: 'Kopi til meg',
      order_report: 'Order report',
      producedProductWeight: 'Vekt på ferdige produksjoner',
      stockOverview: 'Lager beholdning',
      showZeroProduct: 'Vis 0 beholdning',
      timePeriodStart: 'Time period from',
      timePeriodEnd: 'Time period to',
      productGroup: 'Varegr.',
      productNumber: 'Varenr',
      productName: 'Varenavn',
      date: 'Dato',
      qty: 'Ant',
      standardWeight: 'Stdvekt',
      stdWeightTotal: 'Stdvekttotalt',
      checkedWeight: 'Veid vekt',
      productClass: 'produktklasse',
      // productClass: 'Klasse',
      onStock: 'Beholdning',
      bookedValue: 'Bokført verdi',
      materialDemand: 'Behov for produksjonsmateriell',
      from: 'Fra',
      to: 'Til',
      report: 'Rapport',
      productUsage: 'Vareforbruk',
      productionReport: 'Daglig produksjon',
      dateTimeStart: 'Startet',
      dateTimeEnd: 'Fulført',
      bQty: 'B antall',
      usedQty: 'Brukt',
      usedBy: 'Brukt',
      usedDate: 'Brukt dato',
      inventoryReport: 'Lagerverdirapport',
      totalInventoryValue: 'Totalverdi',
      locations: 'Lokasjoner',
      vendor: 'Leverandør',
      totalInventory: 'Total beholdning',
      prodNo: 'Prod.nr'
    },
    products: {
      number: 'Nummer',
      name: 'Vareslag',
      addProduct: 'Legg til vare',
      updateProduct: 'Oppdater vare',
      elementNumber: 'Elementnummer',
      element_name: 'Elementnavn',
      costPrice: 'Kostpris',
      salePrice: 'Salgspris',
      buyerTax: 'MVA %',
      listPrice: 'Uts. pris',
      accountNo: 'Konto',
      currency: 'Valuta',
      tax: 'Tax',
      unit: 'Enhet',
      discount: 'Rabatt %',
      supp: 'Supp.prodnbr',
      suppNumber: 'Lev. varenr',
      length: 'Lengde',
      netWeight: 'Nettovekt',
      width: 'Bredde',
      height: 'Høyde',
      addPackage: 'Legg til vare/stykkliste',
      editPackage: 'Rediger vare/stykkliste',
      updatePackage: 'Oppdater vare/stykkliste',
      cement: 'Betong',
      cementQuality: 'Betong kvalitet',
      type: 'Type',
      group: 'Produktgruppe',
      thickness: 'Tykkelse',
      copy_confirm_head: 'Kopier element',
      copy_confirm_msg: 'Vil du opprette en kopi?',
      multiple: 'Flere',
      deliveryTime: 'Lev. tid',
      decimals: 'Decimaler',
      operation_type: 'Operasjon',
      new_fields: 'Ekstra informasjon',
      plan_measures: 'Planmål',
      forging_measures: 'Smimål',
      order_measures: 'Best. Mål',
      plan_weight: 'Planvekt',
      forging_weight: 'Smivekt',
      showActive: 'Bare aktive',
      returnProductTitle: 'Forbruksmateriell (forbruk og retur)',
      retQty: 'Antall',
      return: 'Returneres til lager',
      statusChangeWarn: 'Status for ett eller flere produkter er blitt endret. Lageret vil bli justert med antall brukt i produksjon. Vil du endre antallet og fortsette?',
      updateConfirm: 'Bekreft oppdatering',
      standard_weight: 'Standard vekt',
      stampOutChange: 'Return product to change status',
      errorWorkflow: 'Velg arbeidsflyt',
      syncTripletex: 'Synk. fra Tripletex',
      syncStarted: 'Synkronisering skjer i bakgrunnen!',
      tripletexUser: 'Tripletex bruker',
      copyAsNew: 'Kopier til nytt produkt',
      copyOnlyContents: 'Kopier BOM',
      copyTo: 'Velg produkt',
      copyToValidation: 'Vennligst velg produkt å kopiere til!'
    },
    users: {
      active: 'Aktiv'
    },
    crm: {
      name: 'Navn'
    },
    invoice: {
      saveAs: 'Opprett',
      saveAsDraft: 'Kladd',
      saveAndEmail: 'Faktura på epost',
      saveAndDownloadPDF: 'Faktura som PDF',
      saveAndUseEHF: 'Send EHF faktura'
    },
    userRole: {
      administrator: 'Administrator',
      office: 'Kontor',
      technician: 'Vanlig',
      technicians: 'Teknikere'
    },
    returnForm: {
      companyName: 'Selskap/Navn',
      companyNo: 'Orgnr',
      add: 'Legg til',
      update: 'Oppdater'
    },
    props: {
      new: 'Ny',
      name: 'Navn',
      description: 'Beskrivelse',
      label: 'Etikett',
      type: 'Type',
      placeholder: 'Plassholder',
      isActive: 'Er aktiv',
      actions: 'Handlinger',
      value: 'Verdi',
      properties: 'egenskaper',
      options: 'Alternativer',
      addProps: 'Legg til egenskaper',
      updateProps: 'Oppdater egenskaper',
      formAttributes: 'Skjema egenskaper',
      useAsTitle: 'Bruk som tittel',
      validation: 'Validering',
      isMultiSelect: 'Har flervalg',
      defaultValue: 'Standar verdi',
      enterValue: 'Angi en av verdiene fra alternativet',
      isApi: 'er API',
      apiUrl: 'API URL',
      objectName: 'Objektnavn',
      columns: 'Kolonner',
      gridColumns: 'Kolonner',
      question: 'Spørsmål?',
      link: 'Html',
      enterTitleOfColumn: 'Kolonnenavn',
      loadingGrid: 'Laster inn...',
      favourite: 'Favoritt',
      customProperties: 'Egendefinerte egenskaper',
      enterTitle: 'Skriv inn tittel',
      rows: 'Rader',
      preparingFields: 'Forbereder feltene',
      dragging: 'Dra ...',
      fontSize: 'Skriftstørrelse',
      preview: 'Forhåndsvisning',
      hideComments: 'Hide Comments',
      hideAttachments: 'Hide Attachments',
      defaultValueKeyword: 'Standardverdi etter søkeord',
      setCurrentUserAsDefault: 'Set current user as default',
      rowsToAutoCreate: 'Rows to auto create on checklist create',
      showInNextRow: 'Show in next row',
      addTopSpace: 'Add top space',
      optionsValuesAreNotUnique: 'Options list values are not unique',
      viewType: 'View type',
      showWidthField: 'Show width field above header',
      enterTitleAndWidthOfColumn: 'Enter title and width of the column',
      fieldInfo: 'Field info',
      valueForCalculation: 'Value for calculation',
      customFieldsNotAvailable: 'Custom field not available',
      selectStatus: 'Select status',
      template: 'Template',
      drag: 'Drag',
      showSum: 'Show sum'
    },
    form: {
      updateFormProps: 'Oppdater skjema',
      addNewForm: 'Legg til ny skjema',
      selectGroup: 'Velg gruppe',
      addHeader: 'Legg til Header',
      addFooter: 'Legg til Footer',
      formProps: 'Skjemaegenskaper',
      allCaughtUp: 'Lest alle oppdatering',
      dropFields: 'Slipp feltene her!',
      addHtmlContent: 'Legg til HTML innhold',
      forHeader: 'Overskrift',
      forFooter: 'Bunntekst',
      comments: 'Kommentar',
      attachments: 'Vedlegg',
      sureToCloneFields: 'Er du sikker på at du vil klone feltet?',
      documents: 'Dokumenter',
      document: 'Dokument',
      updateDocument: 'Oppdater dokument',
      addGroup: 'Legg til gruppe',
      updateGroup: 'Oppdater gruppe',
      date: 'Dato',
      signature: 'Signatur'
    },
    checklist: {
      addChecklist: 'Sjekkliste',
      updateChecklist: 'Endre sjekkliste'
    }
  }
}
